import { GlobalSearchPath } from './../../constants/global-search-path';
import { Router } from '@angular/router';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import * as moment from "moment";
import { AppMainService } from 'src/app/app-main.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { CalendarEventService, EmailAuditService, TaskService } from 'src/app/shared/api/api';
import { CalendarEvent, EmailAudit } from 'src/app/shared/model/models';
import { ActivityService } from "./activity.service";
import { LogService, NoteService } from "./api/api";
import { TaskCategory } from "../../model/models";
import { MessageService } from "primeng/api";
import { DatePipe } from '@angular/common';
import { ObjectNames } from "../../constants/object.names";
import { SOChannel } from 'src/app/inventory/sales-order/constants/constants';
import { CONTACT_ASSOCIATION_IDS_MODULES } from '../../constants/typeId';
import { LionSharedEmailsComponent } from '../shared-emails/shared-emails.component';
import { ImportserialService } from '../../services/importserial.service';
import { Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ParseHelper } from '../../parse.helper';

@Component({
	selector: "app-lion-shared-activities",
	templateUrl: "./shared-activities.component.html",
	styleUrls: ["./shared-activities.component.scss"],
	providers: [
		LogService,
		NoteService,
		ActivityService,
		CalendarEventService,
		TaskService,
	],
})
export class LionSharedActivitiesComponent implements OnInit, OnChanges {
	displayTaskDetails = false;
	displayEditEvent = false;
	task;
	note;
	log;
	eventMode = "";
	event: CalendarEvent;
	emailAudit: EmailAudit;
	showSpinner: boolean = false;

	filters = {
		ALL_ACTIVITY: 'allactivity',
		USER_ACTIVITY: 'useractivity',
		SYSTEM_ACTIVITY: 'systemactivity',
		LOG: 'log',
		NOTE: 'note',
		EMAIL: 'email',
		FAVORITE: 'favorite'
	};

	//comment modal
	displayCommentAdd: boolean = false;
	tempComment;
	nextStageIdForUpdate;
	commentFormType;
	filterType = "allactivity";

	dataId;
	objectNames = ObjectNames;
	emailAuditId;

	@Input() hideRigthArrow: boolean = false;
	@Input() hideMenuBar: boolean = false;
	@Input() objectId;
	@Input() objectTypeId;
	@Input() selectedObject;
	@Input() objectType;
	@Input() contacts;
	@Input() selectedObjectStages = [];
	@Input() isViewMode = false;
	@Input() fromAccountView = false;
	@Input() hideEmailSyncIcon: boolean = true;
	@Input() showActivityLoader: boolean = true;

	@Output() object = new EventEmitter();
	@Output() taskAdded = new EventEmitter<any>();
	@Input() channelId: number;

	@ViewChild(LionSharedEmailsComponent) lionSharedEmailsComponent: LionSharedEmailsComponent;
	assestBaseUrl: string = environment.assestsBasePath;

	stages = [];
	currentObjectType;
	commentHeaderName: string;

	activityLogsData: Array<any>;
	activitySidebar = false;

	activityListDataAll = [];
	activityListData15 = [];
	activityListData = [];
	activityListData2 = [];

	displaySendEmail = false;
	displayAddLog = false;
	displayNotesAdd = false;
	isView = true;

	//task
	displayTaskDetail = false;
	taskTemp = {
		"id": 0,
		"user": "",
		"date": "",
		"fromTime": "",
		"endTime": "",
		"header": "",
		"message": "",
		"type": "Task",
		"email": "",
		"status": "",
		"taskId": "",
		"taskStatus": "",
		"assignedTo": "",
		"category": "",
		"relatedTo": "",
		"repeatType": "",
		"timezone": "",
		"description": "",
		"taskStatuses": [
			{
				id: 0,
				createdByName: this.app.user.name,
				createdDate: new Date(),
				taskStatus: "Assigned"
			},
		]
	}
	activeUsers = [];
	selectedUsers = [];
	taskCategories: TaskCategory[] = [];
	selectedTaskCategory;
	taskStatuses: [
		{ id: 1, name: "Assigned" },
		{ id: 2, name: "In Progress" },
		{ id: 3, name: "Completed" },
		{ id: 4, name: "Accepted" },
	];
	selectedTaskStatus;
	showStatusValidation: boolean = false;
	uploadedFiles: any[] = [];

	//log & note
	displayLogDetailPopup = false;
	displayNoteDetailPopup = false;
	logData;
	noteData;
	//event
	displayEventDetail = false;
	eventTemp = {
		"id": 0,
		"user": "",
		"date": "",
		"fromTime": "",
		"endTime": "",
		"header": "",
		"message": "",
		"type": "Event",
		"email": "",
		"userLists": [],
		"location": ""
	};
	allUsersList: any[];
	usersList = [];
	isShownOptional = false;
	minimumDate: Date;
	evtMsg = "";

	//email
	displayEmailDetail = false;

	displayEmailDetailPopup = false;
	emailData;

	//activity list
	displayAllActivityLists = false;
	//system generated
	ItemRouterLink;
	caseTemp = {
		"id": 0,
		"user": "",
		"date": "",
		"header": "",
		"message": "",
		"type": "Case",
		"taskId": "",
		"filter": "system",
		"category": "",
		"subCategory": "",
		"mark": false,
		"comments": []
	};

	displayDetailPopup = false;
	popupHeader = '';
	moduleName = '';
	moduleType = '';
	itemRouterLink = '';
	detailsData;
	changeDitect: any;
	favoriteClicked = false;

	// Active / Inactive

	activeInactiveFormType: string;
	displayActiveInactiveModal: boolean = false;
	activeInactiveData: any;

	// Email Reply
	displayEmailReplyPopup: boolean = false;
	emailReplyData: any;

	soChannel = SOChannel;

	paths = GlobalSearchPath;

	associationTypeId: number = 0;

	// fraction digits
	fractionDigits: number = 0;
	protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    emailSyncTooltip: string = `Email Sync is running...
                        More than 10 Email will sync in background which may take some times.
                        You can refresh to see the latest`;

	constructor(
		private activityService: ActivityService,
		private router: Router,
		public app: AppMainComponent,
		private noteService: NoteService,
		private logService: LogService,
		private appMainService: AppMainService,
		private emailAuditService: EmailAuditService,
		private messageService: MessageService,
		private datePipe: DatePipe,
		private importService: ImportserialService
	) {
	}

	//populate Draft count when click on Email
	populateDraftCount() {
		this.displaySendEmail = true;
		this.lionSharedEmailsComponent.populateDraftCount();
	}

	ngOnChanges(changes: SimpleChanges) {
		this.changeDitect = changes;
		for (let property in changes) {
			if ((property === 'objectId' && changes[property].currentValue)) {
				const checkAccount = changes?.selectedObject?.currentValue?.accountNumber == '' ? "Account" : changes?.selectedObject?.currentValue?.accountNumber;
				if (changes?.objectType?.currentValue === "Account" || changes?.objectType?.currentValue === "Lead" || checkAccount != null) {
					this.fromAccountView ? this.app.getAllActivityLog("lastfiveactivity", "allactivity", 1, 5, "", true, true, false, this.showActivityLoader) :
						this.app.getAllObjects(this.showActivityLoader, false, false);
				}
				else {
					this.app.getAllObjects(this.showActivityLoader);
				}

				// || property === "objectType"
				//this.app.getAllActivityLog("lastsevendays", "allactivity", 1, 10, "", true, true);
			}
		}
		if (changes?.hideEmailSyncIcon?.currentValue) {
			this.hideEmailSyncIcon = changes.hideEmailSyncIcon.currentValue;
		}

		if (changes && changes.selectedObjectStages && changes.selectedObjectStages.currentValue) {
			this.stages = changes.selectedObjectStages.currentValue;
		}

		if (changes && changes.objectType && changes.objectType.currentValue) {
			this.currentObjectType = changes.objectType.currentValue;
		}

		if (changes?.isViewMode?.currentValue) {
			this.isViewMode = changes.isViewMode.currentValue;
		}

		this.activeUsers = this.app.usersList.filter(obj => obj.statusId == 1);
		this.activityListData15 = this.activityListDataAll.filter((val, i) => i < 15);
		this.activityListData = JSON.parse(JSON.stringify(this.activityListData15));
		this.activityListData = JSON.parse(JSON.stringify(this.activityListDataAll));


	}

	ngOnInit() {
        this.currentObjectType = ParseHelper.DeepCopy(this.app.objectType);
		this.getFractionDigits();
	}

	getFractionDigits() {
        this.importService
            .getDecimalValue()
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe({
                next: (value) => {
                    if(value){
                        this.fractionDigits = value;
                    }
                },
                error: (error) => {},
            });
    }

	filterActivities(filterType) {
		this.filterType = filterType;
		this.app.getAllActivityLog("lasttenactivity", this.filterType, 1, 10, "", true, true);
	}

	toggleFavourite(id, isFavorite, filterValue) {
		this.favoriteClicked = true;

		this.appMainService.isShowSpinner("toggleFavourite");

		this.activityService.toggleFavourite(id, isFavorite, filterValue.toLowerCase())
			.then(() => {
				this.appMainService.isHideSpinner("toggleFavourite");

				let summary = filterValue;
				summary += isFavorite ? ' added to favorites' : ' removed from favorites';

				this.messageService.add({ severity: 'success', summary, detail: '' });

				let data = this.app.allActivityLogs.find(data => data.id == id);
				data.isFavorite = isFavorite;

				this.favoriteClicked = false;
			})
			.catch(() => {
				this.appMainService.isHideSpinner("toggleFavourite");
				this.favoriteClicked = false;
			})
	}

	openUpdateStagePopup(data: { id: number, type: string, comment?: Comment }) {
		this.displayCommentAdd = true;
		this.selectedObject = this.selectedObject;
		this.tempComment = data.comment;
		this.nextStageIdForUpdate = data.id;
		this.commentFormType = data.type;
		if (this.tempComment.objectType == 'Lead') {
			this.commentHeaderName = `${this.tempComment.objectType} Name : ${this.selectedObject.businessName}`;
		}
		else if (this.tempComment.objectType == 'Case') {
			this.commentHeaderName = `${this.tempComment.objectType} No : ${this.selectedObject.sequenceNumber}`;
		}
		else {
			this.commentHeaderName = `${this.tempComment.objectType} Name : ${this.selectedObject.name}`;
		}
	}

	onCommentSaved(event) {
		this.displayCommentAdd = false;
		event && event.comment &&
			this.object.emit(
				{
					formType: event.formType,
					comment: event.comment,
					objectRecordId: event.objectRecordId
				}
			);
	}

	onCancelComment() {
		this.displayCommentAdd = false;
	}

	commentCancelClicked() {
		this.displayCommentAdd = false;
	}

	onCommentDelete() {
		this.displayCommentAdd = false;
	}

	openActivityDetail(s) {
		if (this.favoriteClicked) {
			return;
		}

		if (s.type == this.objectNames.TASK) {
			this.openTaskDetail(s);
		} else if (s.type == this.objectNames.EVENT) {
			this.openEventDetail(s);
		} else if (s.activityName == this.objectNames.LOG) {
			this.openLogDetail(s);
		} else if (s.activityName == this.objectNames.NOTE) {
			this.openNoteDetail(s);
		} else if (s.activityName == this.objectNames.EMAIL) {
			this.emailAudit = null;
			this.openEmailDetail(s);
		}
		else if (s.type == this.objectNames.LEAD) {
			this.openLeadDetail(s);
		}
		else if (s.type == this.objectNames.CONTACT) {
			this.openContactDetail(s);
		} else if (s.type == this.objectNames.ACCOUNT && s.objectData?.action != 'Convert') {
			this.openAccountDetail(s);
		} else if (s.type == this.objectNames.ACCOUNT && s.objectData?.action == 'Convert') {
			const payloadDetails = s.objectData?.payload ? JSON.parse(s.objectData?.payload) : null;

			if (s.objectData?.objectId == 2 && payloadDetails.LeadId) {

				if (s.lead) {
					s.lead['id'] = payloadDetails.LeadId;
				} else {
					s.lead = { id: payloadDetails.LeadId };
				}

				this.openLeadDetail(s);
			} else {

				if (s.account) {
					s.account['id'] = payloadDetails?.AccountId;
				} else {
					s.account = { id: payloadDetails?.AccountId };
				}

				this.openAccountDetail(s);
			}

		} else if (s.type == this.objectNames.OPPORTUNITY) {
			this.openOpportunityDetail(s);
		} else if (s.type == this.objectNames.CASE) {
			this.openCaseDetail(s);
		} else if (s.filter == 'system') {
			this.setDetailsPopupData(s);
		} else if (s.type == 'ActivityLeadLog' || s.type == 'ActivityOpportunityLog' || s.type == 'ActivityCasesLog') {
			if (s.objectData) {
				let activity = s.objectData;
				activity['objectType'] = s.type == 'ActivityLeadLog' ? 'Lead' :
					s.type == 'ActivityOpportunityLog' ? 'Opportunity' : 'Case';
				this.openUpdateStagePopup({ id: activity.stageId, type: 'View', comment: activity });
			}
		}
		else if (s.type == 'StageChange') {
			if (s.objectData) {
				let activity = s.objectData;
				activity['objectType'] = 'Case';
				this.commentFormType = 'Add'; // For hidding
				this.openUpdateStagePopup({ id: activity?.StageId, type: 'View', comment: activity });
			}
		}
		else if (s.type == 'ActiveInactiveContactLog' || s.type == 'ActiveInactiveOpportunityLog'
			|| s.type == 'ActiveInactiveAccountLog' || s.type == 'ActiveInactiveLeadLog') {
			if (s.objectData) {
				s.objectData['objectType'] = s.type == 'ActiveInactiveLeadLog' ? 'Lead' :
					s.type == 'ActiveInactiveOpportunityLog' ? 'Opportunity' :
						s.type == 'ActiveInactiveAccountLog' ? 'Account' : 'Contact';
				this.openActiveInactiveModal(s);
			}
		}
		else if (s.type == 'EmailReply') {
			this.openEmailReplyPopup(s);
		}
	}

	openActiveInactiveModal(data: any): void {
		let moduleName: string = '';
		switch (data?.type) {
			case 'ActiveInactiveContactLog':
				moduleName = 'Contacts';
				break;
			case 'ActiveInactiveOpportunityLog':
				moduleName = 'Opportunity';
				break;
			case 'ActiveInactiveLeadLog':
				moduleName = 'Lead';
				break;
			case 'ActiveInactiveAccountLog':
				moduleName = 'Account';
				break;
		}
		const status: string = (data?.objectData?.status?.id == 1) ? 'Active' : 'Inactive';
		this.commentHeaderName = moduleName + ' ' + status + ' Details';
		this.activeInactiveFormType = 'View';
		this.displayActiveInactiveModal = true;
		this.activeInactiveData = data;
		this.moduleName = moduleName;
	}

	cancelActiveInactiveModal(): void {
		this.commentHeaderName = '';
		this.activeInactiveFormType = '';
		this.moduleName = '';
		this.displayActiveInactiveModal = false;
		this.activeInactiveData = null;
	}

	openLogDetail(s) {
		this.logService.lionO36020APILogIdGet(s.objectData.log.id).subscribe((log: any) => {
			this.logData = log;
			this.displayLogDetailPopup = true;
		});

		this.activitySidebar = false;
	}

	cancelLogPopupDetails() {
		this.logData = null;
		this.displayLogDetailPopup = false;
		//this.app.getAllActivityLog("lastsevendays", "allactivity", 1, 10, "", true, true);
	}

	  transformComment(value: string): string {
		return value ? value.replace(/\r\n/g, '<br>') : '';
	  }

	openNoteDetail(s) {
		this.noteService.lionO36020APINoteIdGet(s.objectData.note.id).subscribe(note => {
			this.noteData = note;
			this.displayNoteDetailPopup = true;
		});

		this.activitySidebar = false;
	}

	cancelNotePopupDetails() {
		this.noteData = null;
		this.displayNoteDetailPopup = false;
		//this.app.getAllActivityLog("lastsevendays", "allactivity", 1, 10, "", true, true);
	}

	openTaskDetail(s) {
		this.taskTemp = JSON.parse(JSON.stringify(s));
		this.displayTaskDetail = true;
		this.isView = true;
	}

	openEventDetail(s) {
		this.eventTemp = JSON.parse(JSON.stringify(s));
		this.allUsersList = [...this.app.usersList];

		let date = this.datePipe.transform(this.eventTemp.fromTime, 'MM/dd/yyyy');
		let from = this.datePipe.transform(this.eventTemp.fromTime, 'HH:mm a');
		let end = this.datePipe.transform(this.eventTemp.endTime, 'HH:mm a');
		this.evtMsg = "This event will take place on " + date + " from " + from + " to " + end;

		this.displayEventDetail = true;
		this.isView = true;
	}

	openEmailDetail(s) {
		this.displayEmailDetailPopup = true;
		this.emailAuditId = s.id;
		this.emailAuditService.lionO36020APIEmailAuditIdGet(s.id, true).subscribe((email: any) => {
			let emailAuditDetails: EmailAudit = email;
			emailAuditDetails.emailThreads.forEach(elem => { elem.receivedDateTime = elem.receivedDateTime });
			emailAuditDetails.emailThreads = emailAuditDetails.emailThreads.sort(function (left, right) {
				return moment.utc(right.receivedDateTime).diff(moment.utc(left.receivedDateTime))
			});
			this.emailAudit = emailAuditDetails;
		});
	}

	openLeadDetail(s) {
		this.moduleType = this.objectNames.LEADS;
		this.displayDetailPopup = true;
		this.popupHeader = "Lead Details";
		this.dataId = s?.objectData?.objectRecordId;
	}

	openContactDetail(s) {
		this.moduleType = this.objectNames.CONTACT;
		this.displayDetailPopup = true;
		this.popupHeader = "Contact Details";
		this.dataId = s?.objectData?.objectRecordId;
		this.associationTypeId = CONTACT_ASSOCIATION_IDS_MODULES[`OBJECTID_${s?.objectData?.refObjectId}`];
	}

	openAccountDetail(s) {
		this.moduleType = this.objectNames.ACCOUNT;
		this.displayDetailPopup = true;
		this.popupHeader = "Account Details";
		this.dataId = s?.objectData?.objectRecordId;
	}

	openOpportunityDetail(s) {
		this.moduleType = this.objectNames.OPPORTUNITY;
		this.displayDetailPopup = true;
		this.popupHeader = "Opportunity Details";
		this.dataId = s?.objectData?.objectRecordId;
	}

	openCaseDetail(s) {
		this.moduleType = this.objectNames.CASES;
		this.displayDetailPopup = true;
		this.popupHeader = "Case Details";
		this.dataId = s?.objectData?.objectRecordId;
	}

	cancelEmailPopupDetails() {
		this.emailData = null;
		this.displayEmailDetailPopup = false;
		//this.app.getAllActivityLog("lastsevendays", "allactivity", 1, 10, "", true, true);
	}

	openEmailReplyPopup(data: any): void {
		this.displayEmailReplyPopup = true;
		//this.emailReplyData = data;
		this.getEmailReplyActivity(data?.id);
	}

	getEmailReplyActivity(id: number): void {
		this.appMainService.isShowSpinner("emailReplyActivity");
		this.activityService.getEmailReplyActivity(id).then((response) => {
			this.emailReplyData = response;
			this.appMainService.isHideSpinner("emailReplyActivity");
		},
			(error) => {
				this.messageService.add({ severity: 'error', summary: 'Error Occured', detail: error?.error?.message });
				this.appMainService.isHideSpinner("emailReplyActivity");
			});
	}

	cancelEmailReplyPopup(): void {
		this.displayEmailReplyPopup = false;
		this.emailReplyData = null;
	}

	onUpload(event) {
		for (let file of event.files) {
			this.uploadedFiles.push(file);
		}

		this.messageService.add({ severity: 'info', summary: 'File Uploaded', detail: '' });
	}

	//activity list
	search(query) {
		const filtered: any[] = [];
		for (let l of this.allUsersList) {
			if (l.name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
				filtered.push(l);
			}
		}
		this.usersList = [...filtered];
	}

	showOptional() {
		this.isShownOptional = !this.isShownOptional;
	}

	openAllActivityList() {
		this.displayAllActivityLists = true;
		this.activityListData2 = JSON.parse(JSON.stringify(this.activityListDataAll));
	}

	emailSync(emailAuditId: number = 0) {
		this.showSpinner = true;
		this.activityService.getEmailSync(this.objectId, this.app.objectTypeId, emailAuditId).subscribe(
			{
				next: (res) => {
					this.showSpinner = false;
					this.app.getAllActivityLog("lasttenactivity", "allactivity", 1, 10, "", true, true, true);
				},
				error: (error) => {
					this.showSpinner = false;
				}
			});
	}

	closeActivityDialog() {
		this.displayAllActivityLists = false;
	}

	setDetailsPopupData(s) {
		this.displayDetailPopup = true;
		this.moduleName = s.type;
		this.popupHeader = s.type + ' Details';
		this.detailsData = JSON.parse(JSON.stringify(s));

		if (s.type == 'Case') {
			this.itemRouterLink = '/cases';
		} else if (s.type == 'Opportunity') {
			this.itemRouterLink = '/opportunities';
		}
	}

	closeDialog() {
		this.displayDetailPopup = false;
	}

	cancelEmail(event) {
		this.displaySendEmail = event.cancelEmail;
	}

    openLogs(){
        this.app.objectId = this.objectId;
        this.app.objectType = this.currentObjectType;
        this.app.objectTypeId = this.objectTypeId;
        this.displayAddLog = true;
    }

	cancelLog(event) {
		this.displayAddLog = event.cancelEmail;
	}

	cancelNote(event) {
		this.displayNotesAdd = event.cancelEmail;
	}

	newTaskAdded() {
		this.taskAdded.emit({ "taskAdded": true });
	}

	convertPageNavigation(s) {

		let url = "";
		const payloadDetails = s.objectData?.payload ? JSON.parse(s.objectData?.payload) : null;
		let businessName = "";
		let splitedText = s.objectData.comment.split(':');
		if (s?.objectData?.comment && splitedText.length > 1) {
			businessName = splitedText[1]?.trim();
		}

		let queryParams = {
			id: 0,
			channelId: payloadDetails?.TypeId || 1,
			module: s.type,
			statusId: payloadDetails?.StatusId || 1,
			globalSearch: true,
			data: businessName,
		};

		if (s.objectData?.objectId == 2 && payloadDetails?.LeadId) {
			url = this.paths.Lead;
			queryParams.id = payloadDetails.LeadId;
			queryParams.module = 'Leads';
		} else {
			url = this.paths.Account;
			queryParams.id = payloadDetails?.AccountId;
			queryParams.module = 'Account';
		}

		this.router
			.navigateByUrl("/", { skipLocationChange: true })
			.then(() =>
				this.router.navigate([url], {
					queryParams
				})
			);
	}

	syncSendEmail(mailObj: any) {
		this.app.loadingActivityLogs = true;
		setTimeout(() => {
			this.emailSync(mailObj?.emailAudit?.id ?? mailObj?.emailAuditId ?? 0);
		}, 2000);
	}
}
